import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";

// Icons
import CloseIcon from "@mui/icons-material/Close";
import BackspaceIcon from "@mui/icons-material/Backspace";

import { useDispatch, useSelector } from "react-redux";
import LoadingBox from "../../misc/Loading";
import ProductSmall from "../../product/ProductSmall";
import { clearWishlist } from "../../../reduxToolkit/features/frontend/wishlist";
import LoadingButton from "@mui/lab/LoadingButton";
import { colors, fonts, radii } from "../../../theme/designTokens";

// Media Query
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function WishListDrawer({ wishOpen, setWishOpen }) {
  // Media Query
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const dispatch = useDispatch();
  //   UseState
  const [emptyWish, setEmptyWish] = useState(false);

  const [loadingMain, setLoadingMain] = useState(false);
  const [lang, setLang] = useState("");

  const [wishMedArr, setWishMedArr] = useState([]);

  const [catList, setCatList] = useState([]);

  // Store
  const { medicines, categories } = useSelector((state) => state.medicine);
  const { activeLangFront } = useSelector((state) => state.miscFront);
  const { wishlist } = useSelector((state) => state.wishlist);

  // Function
  const removeAllWishList = () => {
    dispatch(clearWishlist());
    setLoadingMain(true);
    setTimeout(() => {
      setEmptyWish(false);
      setLoadingMain(false);
    }, 1000);
  };

  // Initialization
  useEffect(() => {
    // if (!(medicines && medicines.length > 0)) dispatch(getMedicines());
  }, []);

  // Set Language
  useEffect(() => {
    if (activeLangFront) setLang(activeLangFront.langCode);
  }, [activeLangFront]);

  // set Category
  useEffect(() => {
    if (lang !== "" && categories && categories.length > 0) {
      let C = categories.find((c) => c.lang === lang);
      if (C) setCatList(C.data);
      else setCatList([]);
    }
  }, [categories, lang]);

  useEffect(() => {
    setLoadingMain(true);
    if (medicines && medicines.length > 0) {
      let arr = [];
      const M = medicines.find((x) => x.lang === lang);
      if (M && M.data) {
        if (wishlist && wishlist.length > 0) {
          wishlist.forEach((x) => {
            const med = M.data.find(
              (y) =>
                (lang !== "en" ? y.medicineDetectorId : y.fixedMedicineId) === x
            );
            if (med) {
              arr.push(med);
            }
          });
        }
      }
      setWishMedArr(arr);
    }
    setTimeout(() => {
      setLoadingMain(false);
    }, 1000);
  }, [medicines, wishlist, lang]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <>
      {/* <Dialog
        open={wishOpen}
        aria-labelledby={"compare"}
        TransitionComponent={Transition}
        fullScreen={!smUp}
      > */}
      <Box sx={{ minWidth: !smUp ? "100vw" : "700px", bgcolor: colors.paper, minHeight: "100%" }}>
        <AppBar
          sx={{
            position: "sticky",
            bgcolor: colors.paperTint,
            borderBottom: `1px solid ${colors.line}`,
            boxShadow: "none",
          }}
        >
          <Toolbar>
            <Grid
              container
              spacing={0}
              justifyContent="space-between"
              alignItems="center"
              sx={{ minWidth: 300 }}
            >
              <Grid item>
                <IconButton
                  edge="start"
                  onClick={() => setWishOpen(false)}
                  aria-label="close"
                  sx={{ color: colors.ink2 }}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>

              <Grid item sx={{ flexGrow: 1 }}>
                <Typography sx={{ fontFamily: fonts.display, fontWeight: 800, color: colors.ink }} variant="h6">
                  {translateFront("Wishlist")}
                </Typography>
              </Grid>

              <Grid item>
                <Button
                  variant="outlined"
                  endIcon={<BackspaceIcon />}
                  size="small"
                  fullWidth
                  sx={{
                    textTransform: "none",
                    borderRadius: radii.md,
                    color: "#D14343",
                    borderColor: "#D14343",
                  }}
                  onClick={() => setEmptyWish(true)}
                  disabled={wishlist.length < 1 ? true : false}
                >
                  {translateFront("Clear All")}
                </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>

        <Grid
          container
          spacing={2}
          flexDirection="column"
          alignItems="center"
          sx={{ px: 1, mt: 1 }}
        >
          {loadingMain ? (
            <LoadingBox />
          ) : wishMedArr.length < 1 ? (
            <Grid item xs={12} sx={{ py: 6, textAlign: "center" }}>
              <Typography sx={{ color: colors.ink3, fontSize: 14.5 }}>
                Your wishlist is empty
              </Typography>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Grid container spacing={2} flexDirection="row" justifyContent="center">
                {wishMedArr.map((x, i) => (
                  <Grid item key={i} xs={12} sm={6}>
                    <ProductSmall
                      x={x}
                      i={i}
                      view={0}
                      catList={catList}
                      lang={lang}
                      wishListW={300}
                      setWishOpen={setWishOpen}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )}
        </Grid>
      </Box>

      <Dialog
        open={emptyWish}
        onClose={() => setEmptyWish(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {translateFront("Empty Wishlist?")}
        </DialogTitle>

        <DialogActions>
          <Button onClick={() => setEmptyWish(false)}>
            {translateFront("No")}
          </Button>
          <LoadingButton
            onClick={() => removeAllWishList()}
            loading={loadingMain}
            color="error"
          >
            {translateFront("Yes")}
          </LoadingButton>
        </DialogActions>
      </Dialog>
      {/* </Dialog> */}
    </>
  );
}
